import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IApiReservation } from '../../interfaces/reservation.interface';

@Injectable({
  providedIn: 'root'
})
export class ReservationNotificationService {
  #toastrService: ToastrService = inject(ToastrService);

  async requestNotificationPermission(): Promise<boolean> {
    if (!('Notification' in window)) {
      return false;
    }

    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission === 'denied') {
      return false;
    }

    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  notifyNewReservations(newReservations: IApiReservation[]): void {
    newReservations.forEach(reservation => {
      // Notification toast
      this.#toastrService.success(
        `Nouvelle réservation de ${reservation.Client?.firstname || 'Client'}`,
        'Nouvelle réservation!',
        {
          timeOut: 8000,
          closeButton: true
        }
      );

      this.showBrowserNotification(reservation);
    });
  }

  private showBrowserNotification(reservation: IApiReservation): void {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('Nouvelle réservation!', {
        body: `${reservation.Client?.firstname || 'Un client'} a fait une réservation pour ${reservation.coiffure?.nom}`,
        tag: `reservation-${reservation.id}`
      });
    }
  }
}

